const MASKED_LINKS_INIT_DONE_ATTR = 'data-ents-masked-links-initialized';
const ACCORDION_LINKS_INIT_DONE_ATTR = 'data-ents-accordion-links-initialized';

export const openMaskedLink = (event) => {
  const href = event.currentTarget.getAttribute('data-href');
  const target = event.currentTarget.getAttribute('data-target');
  if (href) {
    event.preventDefault();
    if (target === '_blank') {
      window.open(href, target);
    } else {
      window.location.href = href;
    }
  }
};

export const initMaskedLinks = (container) => {
  if (container.getAttribute(MASKED_LINKS_INIT_DONE_ATTR) === 'true') {
    return;
  }
  container.querySelectorAll('button[data-href]')
    .forEach((element) => {
      element.addEventListener('click', openMaskedLink);
    });
  container.setAttribute(MASKED_LINKS_INIT_DONE_ATTR, 'true');
};

const openAccordionLink = (event) => {
  const target = event.currentTarget.getAttribute('data-accordion-target');
  const targetElement = document.getElementById(`accordion-${target}`);

  if (targetElement) {
    targetElement.setAttribute('open', '');
    const elementY = targetElement.getBoundingClientRect().top + window.scrollY;
    window.scrollTo({
      top: elementY,
      behavior: 'smooth',
    });

    const focusElement = targetElement.children.item(0);

    focusElement.focus({preventScroll: true});
  }
};

export const initAccordionLinks = (container) => {
  if (container.getAttribute(ACCORDION_LINKS_INIT_DONE_ATTR) === 'true') {
    return;
  }
  container.querySelectorAll('button[data-accordion-target]')
    .forEach((element) => {
      element.addEventListener('click', openAccordionLink);
    });
  container.setAttribute(MASKED_LINKS_INIT_DONE_ATTR, 'true');
};

export const initLinks = (container) => {
  initMaskedLinks(container);
  initAccordionLinks(container);
};
